import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from "react-i18next";

import { Link } from 'react-router-dom';

import ProLabel from 'components/common/ProLabel';
import TooltipCommon from 'components/common/TooltipCommon';

import './ProFeaturePlaceholder.css';

class ProFeaturePlaceholder extends Component {
  static propTypes = {
    locked: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
      PropTypes.string,
    ]).isRequired,
    proLabel: PropTypes.bool,
    forFeatureFlag: PropTypes.bool,
    placeholderContent: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
      PropTypes.string,
    ]).isRequired,
    lockBackground: PropTypes.string,
    noKeyIcon: PropTypes.bool,
  };

  static defaultProps = {
    locked: null,
    className: null,
    proLabel: null,
    forFeatureFlag: false,
    placeholderContent: null,
    lockBackground: null,
    noKeyIcon: null,
  };

  state = {
    popupOpen: false,
  };

  onPopupClose = () => {
    this.setState({ popupOpen: false });
  };

  renderTooltipContent = () => (
    <Translation>
      {(t) => (
        <div className="tooltip-content">
          <div className="text-container">
            {!this.props.placeholderContent ?
              <div>
                {t("This is a PRO plan feature.")}
              </div>
              :
              <div>{this.props.placeholderContent}</div>
            }
            {!this.props.forFeatureFlag ?
              <div>
                {t("Check it")} <Link to="/billing">{t("here")}</Link>
              </div>
              :
              <div>
                {t("Please send an email to team@heylink.me")}
              </div>
            }
          </div>
        </div>
      )}
    </Translation>
  );

  renderProFeaturePlaceholder = () => (
    <div
      data-tip
      data-for={`pro-feature-placeholder-tooltip-id`}
      className="blocked-layer"
      onClick={() => this.setState({ popupOpen: true })}
    >
      {!this.props.noKeyIcon &&
        <div
          className="lock-icon-container"
          style={{
            background: this.props.lockBackground,
          }}
        >
          <div className="icon" />
        </div>
      }
    </div>
  );

  render() {
    const { locked, children, className, proLabel } = this.props;

    return (
      <Translation>
        {(t) => (
          <div
            className={`pro-feature-placeholder__component${className ? ` ${className}` : ''}`}
          >
            {proLabel && <ProLabel />}

            {locked &&
              <TooltipCommon
                key="pro-feature-tooltip-key"
                overlayClassName="pro-feature-tooltip__component"
                placement="bottom"
                header={this.props.forFeatureFlag ? t("Feature disabled") : 'PRO' }
                trigger="click"
                visible={this.state.popupOpen}
                closeIcon
                onClose={this.onPopupClose}
                overlay={this.renderTooltipContent()}
              >
                {this.renderProFeaturePlaceholder()}
              </TooltipCommon>
            }
            {children}
          </div>
        )}
      </Translation>
    );
  }
}

export default ProFeaturePlaceholder;
